import React from 'react';

import Link from '../Link';
import Fact from './Fact';

function HoC(props) {
  return (
    <Fact id="valj-produkt" title="Välj produkt med omsorg" {...props}>
      <p>
        {`
          Produkter som tillhör någon av de 33 livsmedelsgrupperna i
          Livsmedelsverkets föreskrift om Nyckelhålet (LIVSFS 2005:9, konsoliderad
          version LIVSFS 2015:1) är de som främst är aktuella för att använda
          kostråd i märkning och marknadsföring.
        `}
      </p>
      <p>
        {`
          Om man vill använda kostråd i märkning eller marknadsföring för
          produkter som inte uppfyller kriterierna för den aktuella
          livsmedelsgruppen i nyckelhålsreglerna eller som inte ingår i någon
          av livsmedelsgrupperna överhuvudtaget får en bedömning göras från fall
          till fall om lämpligheten att använda kostråden. En sådan bedömning
          bör ta sin utgångspunkt i regleringen av vilseledande i artikel 7
          i EU-förordning 1169/2011.
        `}
        <Link to="/faktabank/#vilseledande">
          {'Läs mer under rubriken ”Vilseledande”.'}
        </Link>
      </p>
      <p>
        {`
          Om man önskar lyfta fram hälsosamma aspekter för livsmedel, på vilka
          det är mer tveksamt att ange kostråd, kan man istället för kostråd
          använda näringspåståenden eller mängdangivelse av ingrediens,
          t ex sänkt sockerhalt i sötade drycker, fullkornshalt i bakverk.
        `}
      </p>
    </Fact>
  );
}

export default HoC;



// WEBPACK FOOTER //
// ./src/components/Fact/FactValjProduktMedOmsorg.js